import { Injectable } from '@angular/core';

interface TimeZone {
  timezone: string;
  offset: string;
}

@Injectable({
  providedIn: 'root',
})
export class TimeZoneService {
  private timeZones: TimeZone[] = [
    { timezone: 'UTC', offset: '+00:00' },
    { timezone: 'GMT', offset: '+00:00' },
    { timezone: 'Europe/London', offset: '+00:00' },
    { timezone: 'Europe/Paris', offset: '+01:00' },
    { timezone: 'Europe/Berlin', offset: '+01:00' },
    { timezone: 'Africa/Cairo', offset: '+02:00' },
    { timezone: 'Asia/Jerusalem', offset: '+02:00' },
    { timezone: 'Asia/Riyadh', offset: '+03:00' },
    { timezone: 'Asia/Dubai', offset: '+04:00' },
    { timezone: 'Asia/Karachi', offset: '+05:00' },
    { timezone: 'Asia/Dhaka', offset: '+06:00' },
    { timezone: 'Asia/Bangkok', offset: '+07:00' },
    { timezone: 'Asia/Shanghai', offset: '+08:00' },
    { timezone: 'Asia/Tokyo', offset: '+09:00' },
    { timezone: 'Australia/Sydney', offset: '+10:00' },
    { timezone: 'Pacific/Auckland', offset: '+12:00' },
    { timezone: 'Pacific/Honolulu', offset: '-10:00' },
    { timezone: 'America/Anchorage', offset: '-09:00' },
    { timezone: 'America/Los_Angeles', offset: '-08:00' },
    { timezone: 'America/Denver', offset: '-07:00' },
    { timezone: 'America/Chicago', offset: '-06:00' },
    { timezone: 'America/New_York', offset: '-05:00' },
    { timezone: 'America/Caracas', offset: '-04:00' },
    { timezone: 'America/Sao_Paulo', offset: '-03:00' },
    { timezone: 'Atlantic/South_Georgia', offset: '-02:00' },
    { timezone: 'Atlantic/Azores', offset: '-01:00' },
  ];

  getTimeZones(): TimeZone[] {
    return this.timeZones;
  }
}
